import { Inject, Injectable } from '@angular/core';
import {
  AuthenticationViewContract,
  SecurityAuthenticationViewContractId,
} from '@daas-consulting/security/authentication/frontend/view_contracts';
import { Observable } from 'rxjs';

/**
 * Controla el acceso a páginas que requieren autenticación.
 */
@Injectable({ providedIn: 'root' })
export class AuthNGuard {
  readonly #service: AuthenticationViewContract;

  constructor(
    @Inject(SecurityAuthenticationViewContractId)
    service: AuthenticationViewContract
  ) {
    this.#service = service;
  }

  /**
   * Devuelve true si el usuario está autorizado.
   * Se lo redirije de lo contrario.
   * @returns True si está autorizado. False de lo contrario.
   */
  canActivate(): Observable<boolean> {
    const rv = this.#service.isAuthenticated$;
    return rv;
  }

  /**
   * Determina si un módulo puede ser cargado.
   * @returns Load.
   */
  canLoad(): Observable<boolean> {
    const rv = this.#service.isAuthenticated$;
    return rv;
  }
}
